import React from 'react';
import { Icon } from 'tmt-ui-kit';
import styled from 'styled-components';

import config from '~/config';

const BoxContainer = styled.div`
  border-radius: 6px;
  padding: 24px 16px;
  box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.17);
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

const AvatarImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: block;
  margin: 0 8px;
`;

const Chevron = styled(Icon)`
  font-size: 42px;
  height: 42px;
  width: 46px;
  font-weight: 600;
  cursor: pointer;
`;

const TestimonialText = styled.p`
  text-align: center;
  margin: 0;
  padding: 8px 0;
`;

const Name = styled.p`
  font-weight: 600;
  text-align: center;
  font-size: 20px;
`;

const Company = styled(Name)`
  font-weight: 400;
  font-size: 14px;
`;

const NameContainer = styled.div`
  padding-top: 8px;
`;

const Testimonial = props => {
  const { data, onLeftClick, onRightClick } = props;
  return (
    <BoxContainer>
      <ImageContainer>
        <Chevron onClick={onLeftClick} name="chevron-left" />
        <AvatarImage
          alt={data.name}
          src={`${config.assetPath}/static/images/Affiliate/testimonials/${data.image}`}
        />
        <Chevron onClick={onRightClick} name="chevron-right" />
      </ImageContainer>
      <TestimonialText>{data.text}</TestimonialText>
      <NameContainer>
        <Name>{data.name}</Name>
        <a href={data.link} target="_blank" rel="noopener noreferrer nofollow">
          <Company>{data.company}</Company>
        </a>
      </NameContainer>
    </BoxContainer>
  );
};

export default Testimonial;
